"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPeopleCountPerMode = exports.getModeByName = exports.isValidStop = exports.isValidCategory = exports.isValidMode = exports.categories = exports.modeNames = exports.modes = exports.modesByCategory = exports.modeFamilies = exports.stops = exports.Stop = exports.ModeFamily = exports.ModeName = exports.modeCategories = exports.ModeCategory = void 0;
function getValuesFromEnum(theEnum) {
    return Object.keys(theEnum)
        .map(function (k) { return theEnum[k]; })
        .map(function (v) { return v; });
}
/*
 * ========================================================================================
 *                 CATEGORY (should not have same raw value as a mode)
 * ========================================================================================
 */
var ModeCategory;
(function (ModeCategory) {
    ModeCategory["Drive"] = "drive";
    ModeCategory["SharedRide"] = "shared_ride";
    ModeCategory["PublicTransit"] = "public_transit";
    ModeCategory["Bike"] = "bike";
    ModeCategory["Walk"] = "walk";
    ModeCategory["Remote"] = "remote";
    ModeCategory["Carpool"] = "carpool";
    ModeCategory["None"] = "none";
})(ModeCategory || (exports.ModeCategory = ModeCategory = {}));
exports.modeCategories = getValuesFromEnum(ModeCategory);
/*
 * ========================================================================================
 *                   MODE (should not have same raw value as a category)
 * ========================================================================================
 */
var ModeName;
(function (ModeName) {
    ModeName["Drive"] = "driving";
    ModeName["Carshare"] = "carsharing";
    ModeName["None"] = "none";
    ModeName["CarpoolPassenger"] = "carpool_passenger";
    ModeName["CarpoolDriver"] = "carpool_driver";
    ModeName["Rideshare"] = "ridesharing";
    ModeName["Vanpool"] = "vanpool";
    ModeName["Shuttle"] = "shuttle";
    ModeName["Walk"] = "walking";
    ModeName["Taxi"] = "taxi";
    ModeName["Bike"] = "bicycling";
    ModeName["Bikeshare"] = "bikesharing";
    ModeName["Scooter"] = "scooter";
    ModeName["SharedScooter"] = "sharedScooter";
    ModeName["Bus"] = "bus";
    ModeName["Train"] = "train";
    ModeName["Subway"] = "subway";
    ModeName["Ferry"] = "ferry";
    ModeName["Tramway"] = "tramway";
    ModeName["Remote"] = "remote";
    ModeName["OtherTransit"] = "other_transit";
})(ModeName || (exports.ModeName = ModeName = {}));
var ModeFamily;
(function (ModeFamily) {
    ModeFamily["Activity"] = "ACTIVITY";
    ModeFamily["Active"] = "ACTIVE";
    ModeFamily["Vehicle"] = "VEHICLE";
    ModeFamily["Transit"] = "TRANSIT";
})(ModeFamily || (exports.ModeFamily = ModeFamily = {}));
/*
 * ============================================
 *              STOP (ACTIVITY)
 * ============================================
 */
var Stop;
(function (Stop) {
    Stop["Parking"] = "parking";
    Stop["DropOffKids"] = "drop_off_kids";
    Stop["PhysicalActivity"] = "physical_activity";
    Stop["FoodDrink"] = "food_drink";
    Stop["Meetings"] = "meetings";
    Stop["Errands"] = "errands";
    Stop["Other"] = "other";
})(Stop || (exports.Stop = Stop = {}));
exports.stops = getValuesFromEnum(Stop);
// Used for score calculation constants
exports.modeFamilies = (_a = {},
    // This is used for score calculation and routes with mode "none" should not have their score
    // calculated so this should never be used, but we leave it here for safer typing
    _a[ModeName.None] = ModeFamily.Active,
    _a[ModeName.Bike] = ModeFamily.Active,
    _a[ModeName.Bikeshare] = ModeFamily.Active,
    _a[ModeName.Scooter] = ModeFamily.Active,
    _a[ModeName.SharedScooter] = ModeFamily.Active,
    _a[ModeName.Walk] = ModeFamily.Active,
    _a[ModeName.Remote] = ModeFamily.Active,
    _a[ModeName.CarpoolDriver] = ModeFamily.Vehicle,
    _a[ModeName.CarpoolPassenger] = ModeFamily.Vehicle,
    _a[ModeName.Carshare] = ModeFamily.Vehicle,
    _a[ModeName.Drive] = ModeFamily.Vehicle,
    _a[ModeName.Taxi] = ModeFamily.Vehicle,
    _a[ModeName.Rideshare] = ModeFamily.Vehicle,
    _a[ModeName.Vanpool] = ModeFamily.Vehicle,
    _a[ModeName.Shuttle] = ModeFamily.Transit,
    _a[ModeName.Bus] = ModeFamily.Transit,
    _a[ModeName.Subway] = ModeFamily.Transit,
    _a[ModeName.Train] = ModeFamily.Transit,
    _a[ModeName.Ferry] = ModeFamily.Transit,
    _a[ModeName.Tramway] = ModeFamily.Transit,
    _a[ModeName.OtherTransit] = ModeFamily.Transit,
    _a);
var driveModes = [
    {
        category: ModeCategory.Drive,
        name: ModeName.Drive
    },
    {
        category: ModeCategory.Drive,
        name: ModeName.Carshare
    }
];
var carpoolModes = [
    {
        category: ModeCategory.Carpool,
        name: ModeName.CarpoolDriver
    },
    {
        category: ModeCategory.Carpool,
        name: ModeName.CarpoolPassenger
    }
];
var sharedRide = [
    {
        category: ModeCategory.SharedRide,
        name: ModeName.Taxi
    },
    {
        category: ModeCategory.SharedRide,
        name: ModeName.Vanpool
    },
    {
        category: ModeCategory.SharedRide,
        name: ModeName.Shuttle
    },
    {
        category: ModeCategory.SharedRide,
        name: ModeName.Rideshare
    }
];
var walk = [
    {
        category: ModeCategory.Walk,
        name: ModeName.Walk
    }
];
var bike = [
    {
        category: ModeCategory.Bike,
        name: ModeName.Bike
    },
    {
        category: ModeCategory.Bike,
        name: ModeName.Bikeshare
    },
    {
        category: ModeCategory.Bike,
        name: ModeName.SharedScooter
    },
    {
        category: ModeCategory.Bike,
        name: ModeName.Scooter
    }
];
var publicTransit = [
    {
        category: ModeCategory.PublicTransit,
        name: ModeName.Bus
    },
    {
        category: ModeCategory.PublicTransit,
        name: ModeName.Train
    },
    {
        category: ModeCategory.PublicTransit,
        name: ModeName.Subway
    },
    {
        category: ModeCategory.PublicTransit,
        name: ModeName.Ferry
    },
    {
        category: ModeCategory.PublicTransit,
        name: ModeName.Tramway
    },
    {
        category: ModeCategory.PublicTransit,
        name: ModeName.OtherTransit
    }
];
var remote = [
    { name: ModeName.Remote, category: ModeCategory.Remote }
];
var none = [{ name: ModeName.None, category: ModeCategory.None }];
exports.modesByCategory = (_b = {},
    _b[ModeCategory.Drive] = driveModes,
    _b[ModeCategory.SharedRide] = sharedRide,
    _b[ModeCategory.PublicTransit] = publicTransit,
    _b[ModeCategory.Bike] = bike,
    _b[ModeCategory.Walk] = walk,
    _b[ModeCategory.Remote] = remote,
    _b[ModeCategory.None] = none,
    _b[ModeCategory.Carpool] = carpoolModes,
    _b);
exports.modes = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], driveModes, true), sharedRide, true), walk, true), bike, true), publicTransit, true), remote, true), carpoolModes, true), none, true);
exports.modeNames = getValuesFromEnum(ModeName);
exports.categories = getValuesFromEnum(ModeCategory);
var isValidMode = function (mode) {
    return exports.modeNames.includes(mode);
};
exports.isValidMode = isValidMode;
var isValidCategory = function (category) {
    return exports.modeCategories.includes(category);
};
exports.isValidCategory = isValidCategory;
var isValidStop = function (stop) { return exports.stops.includes(stop); };
exports.isValidStop = isValidStop;
var getModeByName = function (modeName) {
    return exports.modes.find(function (mode) { return mode.name === modeName; }) || null;
};
exports.getModeByName = getModeByName;
exports.defaultPeopleCountPerMode = (_c = {},
    _c[ModeName.None] = 1,
    _c[ModeName.Drive] = 1,
    _c[ModeName.CarpoolPassenger] = 2,
    _c[ModeName.CarpoolDriver] = 2,
    _c[ModeName.Carshare] = 1,
    _c[ModeName.Rideshare] = 1,
    _c[ModeName.Vanpool] = 7,
    _c[ModeName.Shuttle] = 1,
    _c[ModeName.Walk] = 1,
    _c[ModeName.Taxi] = 1,
    _c[ModeName.Bike] = 1,
    _c[ModeName.Bikeshare] = 1,
    _c[ModeName.Scooter] = 1,
    _c[ModeName.SharedScooter] = 1,
    _c[ModeName.Bus] = 1,
    _c[ModeName.Train] = 1,
    _c[ModeName.Subway] = 1,
    _c[ModeName.Ferry] = 1,
    _c[ModeName.Tramway] = 1,
    _c[ModeName.Remote] = 1,
    _c[ModeName.OtherTransit] = 1,
    _c[Stop.Parking] = 1,
    _c[Stop.DropOffKids] = 1,
    _c[Stop.PhysicalActivity] = 1,
    _c[Stop.FoodDrink] = 1,
    _c[Stop.Meetings] = 1,
    _c[Stop.Errands] = 1,
    _c[Stop.Other] = 1,
    _c[ModeCategory.Drive] = 1,
    _c[ModeCategory.SharedRide] = 1,
    _c[ModeCategory.PublicTransit] = 1,
    _c[ModeCategory.Bike] = 1,
    _c[ModeCategory.Walk] = 1,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore -- Keeping in case we delete the mode or it changes to a different name
    _c[ModeCategory.Remote] = 1,
    _c[ModeCategory.Carpool] = 2,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore -- Keeping in case we delete the mode or it changes to a different name
    _c[ModeCategory.None] = 1,
    _c);
//# sourceMappingURL=index.js.map